import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAdminStore } from '../../stores';
import { SideNav, TopBar } from '../instrument/Shell';
import {
  LayoutDashboard, Cpu, FileText, Users, BarChart3, ShieldCheck, Receipt, Building2,
} from 'lucide-react';

const navItems = [
  { to: '/admin/dashboard',   label: 'Dashboard',      icon: LayoutDashboard, key: 'dashboard' },
  { to: '/admin/customers',   label: 'Customers',      icon: Building2,       key: 'customers' },
  { to: '/admin/gpt-config',  label: 'GPT Config',     icon: Cpu,             key: 'gpt-config' },
  { to: '/admin/knowledge',   label: 'Knowledge Base', icon: FileText,        key: 'knowledge' },
  { to: '/admin/tenants',     label: 'Tenants',        icon: Users,           key: 'tenants' },
  { to: '/admin/analytics',   label: 'Analytics',      icon: BarChart3,       key: 'analytics' },
  { to: '/admin/billing',     label: 'Billing',        icon: Receipt,         key: 'billing' },
  { to: '/admin/audit-logs',  label: 'Audit Logs',     icon: ShieldCheck,     key: 'audit-logs' },
];

const pageTitleFor = (path) => {
  const hit = navItems.find((n) => path === n.to || path.startsWith(n.to + '/'));
  return hit ? hit.label : 'Admin';
};

const AdminLayout = () => {
  const { user, logout } = useAdminStore();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const page = pageTitleFor(location.pathname);

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: 'var(--layer-0)' }} data-testid="admin-layout">
      <SideNav
        scope="admin"
        items={navItems}
        userName={user?.name || 'Administrator'}
        userEmail={user?.email}
        onLogout={handleLogout}
      />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar crumbs={['Cognara', 'Control Plane', page]} />
        <main className="flex-1 overflow-y-auto" style={{ background: 'var(--layer-0)' }}>
          <div className="px-6 md:px-8 py-6 md:py-8 max-w-[1600px] mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
